
import React, { useState, useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet-control-geocoder';
const AddGeocoder = ({ coordinatesArray }) => {
  const map = useMap();
  const [query, setQuery] = useState('');

  // Function to handle search
  const handleSearch = () => {
    if (query.trim() !== '') {
      // Check if the query is a valid coordinate
      const coordinatePattern = /^\s*(-?\d+(\.\d+)?),\s*(-?\d+(\.\d+)?)\s*(,\s*-?\d+(\.\d+)?)?\s*$/;
      const match = query.match(coordinatePattern);

      if (match) {
        // Parse the coordinates from the query
        const lon = parseFloat(match[1]);
        const lat = parseFloat(match[3]);
        const position = [lat, lon];

        // Add a marker for the coordinate
        L.marker(position).addTo(map).bindPopup(`Coordinate: [${lon}, ${lat}]`).openPopup();

        // Adjust map view to the marker
        map.setView(position, 20);
      } else {
        // Perform geocoding search for place names
        const geocoder = L.Control.Geocoder.nominatim();
        geocoder.geocode(query, (results) => {
          if (results.length > 0) {
            const latlng = results[0].center;
            map.flyTo(latlng, 20); // Adjust zoom level for a wider view
            L.marker(latlng).addTo(map).bindPopup(results[0].name).openPopup();
          } else {
            alert('No results found for the given query.');
          }
        });
      }
    } else {
      alert('Please enter a search query.');
    }
  };

  useEffect(() => {
    // Add the geocoder control to the map
    const geocoder = L.Control.geocoder({
      defaultMarkGeocode: false,
    })
      .on('markgeocode', function (e) {
        const latlng = e.geocode.center;
        map.flyTo(latlng, 20); // Adjust zoom level for a wider view
        L.marker(latlng).addTo(map).bindPopup(e.geocode.name).openPopup();
      })
      .addTo(map);

    // Cleanup function to remove geocoder control
    return () => {
      geocoder.remove();
    };
  }, [map]);

  useEffect(() => {
    if (coordinatesArray && coordinatesArray.length > 0) {
      // Convert coordinates to [lat, lon] format
      const latLngs = coordinatesArray.map(([lon, lat]) => [lon, lat]);

      // Add markers for each coordinate
      latLngs.forEach(([lat, lon], index) => {
        const position = [lon, lat];
        L.marker(position).addTo(map).bindPopup(`Marker ${index + 1}`).openPopup();
      });

      // Optionally, create a polygon and add it to the map
      const polygon = L.polygon(latLngs, { color: 'blue' }).addTo(map);

      // Adjust the map view to fit all markers
      const bounds = L.latLngBounds(latLngs);
      map.flyTo(bounds);
    }
  }, [coordinatesArray, map]); // Add coordinatesArray and map to dependencies

  return (
    <div className="geocoder-container">
      
    </div>
  );
};

export default AddGeocoder;